/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".selection-container{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;flex-wrap:wrap;align-content:flex-start}.selection-container .selection-item{margin:5px 10px 5px 0}.selection-container button{padding-right:0}.resultSet{margin:5px;padding:5px;border-radius:3px}.resultSet:hover{cursor:pointer!important;background-color:#f8f8f8}.resultSet:focus{background-color:#d3d3d3}.set-defaults{margin-top:1.5rem}"];
export { styles as styles };
